import { render, staticRenderFns } from "./MonitorInfoPanel.vue?vue&type=template&id=56e7128d&"
import script from "./MonitorInfoPanel.vue?vue&type=script&lang=js&"
export * from "./MonitorInfoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports